import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { Job } from 'src/app/shared/models/focusDataModels/Job';
import { LaborShift } from 'src/app/shared/models/laborScheduling/LaborShift.model';

@Component({
	selector: 'app-employee-labor-shift-list',
	templateUrl: './employee-labor-shift-list.component.html',
	styleUrls: ['../../../../commandcenter.scss'],
})
export class EmployeeLaborShiftListComponent implements OnInit, OnDestroy {
	laborShiftList: LaborShift[];

	jobList: Job[];

	selectedLaborShift: LaborShift;

	subscriptions: Subscription = new Subscription();

	constructor(public app: AppService, public venueService: OOVenueService) {}
	ngOnDestroy(): void {
		this.venueService.laborShiftList.next(this.laborShiftList);
		this.subscriptions.unsubscribe();
	}

	ngOnInit(): void {
		this.subscriptions.add(
			this.venueService.laborShiftList.subscribe((data) => {
				this.laborShiftList = data;
				this.attachJobToShift();
			})
		);
		this.subscriptions.add(
			this.venueService.jobList.subscribe((data) => {
				this.jobList = data;
				this.attachJobToShift();
			})
		);
		this.laborShiftList = this.venueService.laborShiftList.value.sort((a, b) => (a.jobId < b.jobId ? -1 : 1));
		this.jobList = this.venueService.jobList.value;
		this.attachJobToShift();
	}

	attachJobToShift() {
		this.laborShiftList?.forEach((shift) => {
			if (!shift.job && this.jobList) {
				shift.job = this.jobList.find((i) => i.id === shift.jobId);
				shift.jobName = shift.job?.name;
			}
		});
	}

	new() {
		this.app.loading(true);

		this.selectedLaborShift = new LaborShift({
			pk: this.venueService.subscriptionVenue.value.key.toString(),
		});
	}

	selectShift(shift: LaborShift) {
		this.app.loading(true);
		this.app.router.navigate([`/cc/employees/schedules/shifts/${shift.shiftKey}`]);
	}
}
